module.exports = __webpack_public_path__ + "static/media/about-1.4470adc9.jpg";